module.exports = "<numeric-keyboard (valueAvailable)='onScaleValueInserted($event)'>\r\n</numeric-keyboard>\r\n"